import clsx from 'clsx';
import { Breadcrumbs, RedesignLayout, useSharedStyles } from '../../shared';
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import ProfileForm from './components/ProfileForm';
import ProfileSummaryCard from './components/ProfileSummaryCard';
import RecrutementModal from './components/RecrutementModal';
import { useProfilePage } from './hooks/useProfilePage';
import locale from './locale.json';
import { useProfileEditStyles } from './index.styles';

const ProfileEdit = () => {
  const classes = useProfileEditStyles();
  const sharedClasses = useSharedStyles();
  const {
    user,
    updateUserById,
    loading,
    loadingUpdate,
    getUser,
    setUser,
    currentUser,
    openRecrutementModal,
    setOpenRecrutementModal,
    showRecrutementBtn,
  } = useProfilePage();

  return (
    <RedesignLayout footer={false} noPadding={true}>
      <div className={clsx(sharedClasses.pageShell, classes.page)}>
        <Breadcrumbs
          items={[{ label: locale.home, href: '/main' }, { label: locale.breadcrumbCurrent }]}
        />

        <div className={classes.content}>
          <ProfileSummaryCard
            user={user || {}}
            currentUser={currentUser}
            setUser={setUser}
            loading={loading}
            showRecrutementBtn={showRecrutementBtn}
            onOpenRecrutement={() => setOpenRecrutementModal(true)}
          />

          {loading ? (
            <div className={sharedClasses.loadingCenter}>
              <div className={classes.skeletonBlock}>
                {[0, 1, 2, 3].map(item => (
                  <Skeleton key={item} variant="rect" height={56} />
                ))}
                <CircularProgress />
              </div>
            </div>
          ) : (
            <ProfileForm user={user || {}} updateUser={updateUserById} loading={loadingUpdate} />
          )}
        </div>
      </div>

      <RecrutementModal
        open={openRecrutementModal}
        user={currentUser}
        onClose={() => setOpenRecrutementModal(false)}
        getUser={getUser}
      />
    </RedesignLayout>
  );
};

export default ProfileEdit;
